import React from "react";
import { Button } from "react-bootstrap";

const CommonBtn = ({
  variant = "primary",
  disabled = false,
  children,
  className = "",
  as = "button",
  onClick = () => {},
  ...rest
}) => {
  return (
    <Button
      variant={variant}
      disabled={disabled}
      className={className}
      onClick={onClick}
      as={as}
      {...rest}
    >
      {children}
    </Button>
  );
};

export default CommonBtn;
